var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      staticClass: "view-container",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
        width: "800px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      [
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u(
              [
                _vm.isEdit
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.showLog },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BusinessPurchaseSupplier.dataForm.titleBtn"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          },
          [
            _vm._v(
              _vm._s(_vm.$t("BusinessPurchaseSupplier.dataForm.title")) + " "
            ),
          ]
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c("BjFormItemCode", {
                  attrs: {
                    label: _vm.$t("BusinessPurchaseSupplier.dataForm.code"),
                    prop: "code",
                    disabled: _vm.isEdit,
                    required: "",
                  },
                  model: {
                    value: _vm.form.code,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "code", $$v)
                    },
                    expression: "form.code",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseSupplier.dataForm.name"),
                      prop: "name",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.classify"
                      ),
                      prop: "type",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.company"
                      ),
                      prop: "fullName",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.fullName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fullName", $$v)
                        },
                        expression: "form.fullName",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.supplierGrade"
                      ),
                      prop: "level",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.level,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "level", $$v)
                        },
                        expression: "form.level",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.mnemonicCode"
                      ),
                      prop: "mnemonic",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.mnemonic,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "mnemonic", $$v)
                        },
                        expression: "form.mnemonic",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseSupplier.dataForm.week"),
                      prop: "cycleDay",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-center" },
                      [
                        _c("el-input-number", {
                          staticClass: "full-width",
                          attrs: {
                            min: 0,
                            max: 99999,
                            label: _vm.$t(
                              "BusinessPurchaseSupplier.dataForm.week"
                            ),
                            controls: false,
                          },
                          model: {
                            value: _vm.form.cycleDay,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "cycleDay", $$v)
                            },
                            expression: "form.cycleDay",
                          },
                        }),
                        _c("span", { staticClass: "ml5" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseSupplier.dataForm.day")
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.proportion"
                      ),
                      prop: "overfillRate",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-center" },
                      [
                        _c("el-input-number", {
                          staticClass: "full-width",
                          attrs: {
                            min: 0,
                            max: 100,
                            label: _vm.$t(
                              "BusinessPurchaseSupplier.dataForm.proportion"
                            ),
                            controls: false,
                          },
                          model: {
                            value: _vm.form.overfillRate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "overfillRate", $$v)
                            },
                            expression: "form.overfillRate",
                          },
                        }),
                        _c("span", { staticClass: "ml5" }, [_vm._v("%")]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.cooperationDate"
                      ),
                      prop: "cooperationDate",
                    },
                  },
                  [
                    _c("BjDateTimerPicker", {
                      model: {
                        value: _vm.form.cooperationDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cooperationDate", $$v)
                        },
                        expression: "form.cooperationDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.invoicing"
                      ),
                      prop: "invoiceType",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: { "lov-code": "SPUR.INVOICE_TYPE" },
                      model: {
                        value: _vm.form.invoiceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "invoiceType", $$v)
                        },
                        expression: "form.invoiceType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.paymentMethod"
                      ),
                      prop: "paymentType",
                    },
                  },
                  [
                    _c("BjInput", {
                      attrs: {
                        maxlength: _vm.MAX_LENGTH.DEFAULT,
                        placeholder: _vm.$t("inputText"),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.paymentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "paymentType", $$v)
                        },
                        expression: "form.paymentType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 12 } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseSupplier.dataForm.taxRate"
                      ),
                      prop: "taxRate",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-center" },
                      [
                        _c("el-input-number", {
                          staticClass: "full-width",
                          attrs: {
                            min: 0,
                            max: 100,
                            label: _vm.$t(
                              "BusinessPurchaseSupplier.dataForm.taxRate"
                            ),
                            controls: false,
                          },
                          model: {
                            value: _vm.form.taxRate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "taxRate", $$v)
                            },
                            expression: "form.taxRate",
                          },
                        }),
                        _c("span", { staticClass: "ml5" }, [_vm._v("%")]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.taxCode"),
                  prop: "taxCode",
                },
              },
              [
                _c("BjInputCode", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.SHORT_NAME,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.taxCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "taxCode", $$v)
                    },
                    expression: "form.taxCode",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.currency"),
                  prop: "currency",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "currency", $$v)
                    },
                    expression: "form.currency",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.gl_Account"),
                  prop: "glAccount",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.glAccount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "glAccount", $$v)
                    },
                    expression: "form.glAccount",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.systemCode"),
                  prop: "systemCode",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.systemCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "systemCode", $$v)
                    },
                    expression: "form.systemCode",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 24 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.remark"),
                  prop: "remark",
                },
              },
              [
                _c("BjTextarea", {
                  attrs: {
                    placeholder: _vm.$t(
                      "BusinessPurchaseSupplier.dataForm.remark"
                    ),
                  },
                  model: {
                    value: _vm.form.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "remark", $$v)
                    },
                    expression: "form.remark",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      [
        _c("BjDivider", [
          _vm._v(_vm._s(_vm.$t("BusinessPurchaseSupplier.dataForm.contact"))),
        ]),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplier.dataForm.contactPerson"
                  ),
                  prop: "contactName",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.contactName,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contactName", $$v)
                    },
                    expression: "form.contactName",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c("BjFormItemEmail", {
              attrs: {
                label: _vm.$t("BusinessPurchaseSupplier.dataForm.email"),
                prop: "contactEmail",
                clearable: "",
              },
              model: {
                value: _vm.form.contactEmail,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "contactEmail", $$v)
                },
                expression: "form.contactEmail",
              },
            }),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.telephone"),
                  prop: "contactTel",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.contactTel,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contactTel", $$v)
                    },
                    expression: "form.contactTel",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c("BjFormItemMobile", {
              attrs: {
                prop: "contactPhone",
                label: _vm.$t("BusinessPurchaseSupplier.dataForm.phone"),
                clearable: "",
              },
              model: {
                value: _vm.form.contactPhone,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "contactPhone", $$v)
                },
                expression: "form.contactPhone",
              },
            }),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("districtNameText"),
                  prop: "contactDistrict",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                  },
                  model: {
                    value: _vm.form.contactDistrict,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contactDistrict", $$v)
                    },
                    expression: "form.contactDistrict",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("detailAddressText"),
                  prop: "contactAddress",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t(
                      "BusinessPurchaseSupplier.dataForm.detailAddress"
                    ),
                  },
                  model: {
                    value: _vm.form.contactAddress,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contactAddress", $$v)
                    },
                    expression: "form.contactAddress",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("cityText"), prop: "contactCity" } },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                  },
                  model: {
                    value: _vm.form.contactCity,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "contactCity", $$v)
                    },
                    expression: "form.contactCity",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("countryText"), prop: "fullAddress" } },
              [
                _c("BjRegionCascader", {
                  staticClass: "full-width",
                  attrs: { "is-array": "", clearable: "" },
                  on: { change: _vm.onChangeRegionCascader },
                  model: {
                    value: _vm.regionList,
                    callback: function ($$v) {
                      _vm.regionList = $$v
                    },
                    expression: "regionList",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("postcodeText"), prop: "postcode" } },
              [
                _c("BjInputCode", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                  },
                  model: {
                    value: _vm.form.postcode,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "postcode", $$v)
                    },
                    expression: "form.postcode",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      [
        _c("BjDivider", [
          _vm._v(
            _vm._s(_vm.$t("BusinessPurchaseSupplier.dataForm.bankInformation"))
          ),
        ]),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t("BusinessPurchaseSupplier.dataForm.account"),
                  prop: "bankName",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.bankName,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "bankName", $$v)
                    },
                    expression: "form.bankName",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplier.dataForm.bankOfDeposit"
                  ),
                  prop: "bankDeposit",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.bankDeposit,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "bankDeposit", $$v)
                    },
                    expression: "form.bankDeposit",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-col",
          { attrs: { span: 12 } },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseSupplier.dataForm.bankAccount"
                  ),
                  prop: "bankAccount",
                },
              },
              [
                _c("BjInput", {
                  attrs: {
                    maxlength: _vm.MAX_LENGTH.DEFAULT,
                    placeholder: _vm.$t("inputText"),
                    clearable: "",
                  },
                  model: {
                    value: _vm.form.bankAccount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "bankAccount", $$v)
                    },
                    expression: "form.bankAccount",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }